import './loadingDrop.css';

export default function LoadingDrop() {
    return (
        <div className="drop" />
    )
}